export default class GroupsAuthoritiesService {
  constructor(http) {
    this.http = http;
  }

  async findAllGroupsAuthorities(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/groupsauthorities/readall?${queryParams}`, {
      method: "GET",
    });
  }

  async createOrUpdateGroupsAuthorities(data) {
    return this.http.fetch(`/api/groupsauthorities/createorupdate`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }
}
